import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraGeneralInfo } from '../../models/doraGeneralInfo.ts';

interface DoraGeneralInfoState {
  generalInfo: DoraGeneralInfo | null;
  loading: boolean;
  error: string | null;
}

const initialState: DoraGeneralInfoState = {
  generalInfo: null,
  loading: false,
  error: null,
};

const doraGeneralInfoSlice = createSlice({
  name: 'doraGeneralInfo',
  initialState,
  reducers: {
    setDoraGeneralInfo(state, action: PayloadAction<DoraGeneralInfo | null>) {
      state.generalInfo = action.payload;
      state.error = null;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    clearDoraGeneralInfo(state) {
      state.generalInfo = null;
      state.error = null;
    },
  },
});

export const {
  setDoraGeneralInfo,
  setLoading,
  setError,
  clearDoraGeneralInfo,
} = doraGeneralInfoSlice.actions;

export const selectDoraGeneralInfo = (state: RootState) => state.doraGeneralInfo.generalInfo;
export const selectDoraGeneralInfoLoading = (state: RootState) => state.doraGeneralInfo.loading;
export const selectDoraGeneralInfoError = (state: RootState) => state.doraGeneralInfo.error;

export default doraGeneralInfoSlice.reducer;
